import React, {
  useEffect,
  useCallback,
  useRef,
  useContext,
  useReducer,
} from "react";
import { connect } from "react-redux";
import axios from "axios";
import { useAlert } from "react-alert";

import errorHandler from "../../../../hoc/ErrorHandler";
import { API_BASE_URL } from "../../../../constants";
import context from "../../../../context/auth-context";
import UnlockForm from "./UnlockForm/UnlockForm";
import SystemCopyright from "../../../UI/SystemCopyright/SystemCopyright";

const AccessTokenAlert = (props) => {
  const initialState = { tMinus: null };

  const reducer = (state, action) => {
    switch (action.type) {
      case "INITIALISE_TIME":
        return { tMinus: parseInt(props.auth.tokenExpiryTminus) };
      case "LAPSE_TIME":
        return { tMinus: state.tMinus - 1 / 60 };
      default:
        throw new Error();
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const authContext = useContext(context);
  const timer = useRef(null);
  const infoLine = useRef(null);
  const countDownDate = useCallback(
    () => new Date(props.auth.tokenExpiry).getTime(),
    [props.auth.tokenExpiry]
  );
  const alert = useAlert();

  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      dispatch({ type: "INITIALISE_TIME" });
      clearInterval(timer.current);

      timer.current = setInterval(() => {
        dispatch({ type: "LAPSE_TIME" });

        let now = new Date().getTime();
        let distance = countDownDate() - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (infoLine.current)
          infoLine.current.innerHTML = `Access token will expire in <span class="badge badge-outline badge-default">${days} d</span> <span class="badge badge-outline badge-success">${hours} h</span> <span class="badge badge-outline badge-warning">${minutes} m</span> <span class="badge badge-outline badge-danger">${seconds} s</span>. Enter your password to renew lease`;

        if (distance < 0) {
          clearInterval(timer.current);
          if (infoLine.current)
            infoLine.current.innerHTML =
              "Access token expired. Enter your password to renew lease";
        }
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countDownDate]);

  if (state.tMinus <= 1 && window.location.hostname !== "localhost") {
    window.$(".dismissible").modal("hide");
    window.$("#tokenExpiryModal").modal("show");
  }

  const renewLeaseHandler = async (credentials) => {
    const response = await axios.patch(
      "/auth/renew-lease",
      {
        ...credentials,
        userId: authContext.userId,
        accessToken: props.auth.accessToken,
        refreshToken: props.auth.refreshToken,
      },
      {
        headers: {
          Authorization: authContext.accessToken.concat(
            ",",
            authContext.refreshToken
          ),
          "Company-Code": authContext.companyCode,
          "Company-Id": authContext.companyId,
        },
      }
    );

    if (response) {
      credentials.password = null;
      window.$("#tokenExpiryModal").modal("hide");
      window.$(".modal-backdrop").remove();

      const data = response.data.data;
      alert.show(response.data.message, { type: "success" });
      props.setTokenIsValid();
      return props.onLeaseRenew(data.token_expiry, data.token_expiry_Tminus);
    }
  };

  return (
    <div
      className="modal fade modal-fill-in modal-newspaper"
      id="tokenExpiryModal"
      aria-hidden="false"
      role="dialog"
      tabIndex="-1"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-simple modal-danger">
        <div className="modal-content">
          <div className="modal-body">
            <div className="page-locked layout-full page-dark">
              <div
                className="page vertical-align text-center"
                data-animsition-in="fade-in"
                data-animsition-out="fade-out"
              >
                <div className="page-content vertical-align-middle">
                  <div className="avatar avatar-lg">
                    <img
                      src={`${API_BASE_URL}/auth/userimage/${authContext.userId}/${authContext.companyCode}`}
                      alt={authContext.userName}
                    />
                  </div>
                  <p className="locked-user">{authContext.userName}</p>
                  <UnlockForm renewLeaseHandler={renewLeaseHandler} />
                  <p ref={infoLine}></p>
                  <p>
                    <a href="/" target="_blank" rel="noopener noreferrer">
                      Or sign in as a different user
                    </a>
                  </p>
                  <SystemCopyright lockScreen />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth.authData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTokenIsValid: () => dispatch({ type: "SET_TOKEN_VALIDITY" }),
    onLeaseRenew: (tokenExpiry, tokenExpiryTminus) =>
      dispatch({
        type: "RENEW_LEASE",
        payload: {
          tokenExpiry: tokenExpiry,
          tokenExpiryTminus: tokenExpiryTminus,
        },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(errorHandler(AccessTokenAlert, axios));
